<template>
  <v-card-actions class="ma-0 pa-0">
    <v-snackbar v-model="showErrorMessage" auto-height dark class="red--text">
      <span>La fecha ingresada es inválida</span>
      <v-btn icon @click="showErrorMessage = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
    <slot></slot>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      :disabled="saving"
      :hidden="withoutTerm"
    >
      <v-text-field
        slot="activator"
        v-model="dateFormatted"
        label="Agregar vencimiento"
        single-line
        :append-icon="(canEdit) ? 'edit':''"
        readonly
        light
        class="pa-0 ma-0 mt-3"
        :loading="saving"
      ></v-text-field>
      <v-date-picker v-if="canEdit" light v-model="date" @input="submit" locale="es-ar"></v-date-picker>
    </v-menu>
    <v-checkbox v-model="currentWithoutTerm" label="Sin plazo" v-on:change="submit" :disabled="!canEdit"></v-checkbox>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    initialDate: String,
    withoutTerm: Boolean,
    criterio: Object
  },

  data: () => ({
    date: '',
    dateFormatted: '',
    lastValidDate: '',
    currentWithoutTerm: false,
    menu: false,
    showErrorMessage: false,
    saving: false
  }),

  computed: {
    canEdit () {
      return this.criterio && this.criterio.allowed
    }
  },

  methods: {
    isValidDate () {
      return this.date >= new Date().toISOString().substr(0, 10)
    },
    submit () {
      if (this.isValidDate() && !this.currentWithoutTerm) {
        this.dateFormatted = this.formatDate(this.date)
        this.saving = true
        let criterionId = this.criterio.pk
        this.axios
          .put(`vencimiento/criterio/${this.criterio.pk}`, { 'date': this.date, 'withoutTerm': this.currentWithoutTerm })
          .then((response) => {
            this.lastValidDate = this.date
            response.data.pk = criterionId
            this.$emit('updateCriterionExpiration', response.data)
            this.saving = false
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.dateFormatted = this.formatDate(this.lastValidDate)
            this.saving = false
          })
      } else {
        this.saving = true
        let criterionId = this.criterio.pk
        this.axios
          .put(`vencimiento/criterio/${this.criterio.pk}`, { 'withoutTerm': this.currentWithoutTerm })
          .then((response) => {
            response.data.pk = criterionId
            this.$emit('updateCriterionExpiration', response.data)
            this.saving = false
            if (!this.currentWithoutTerm) {
              this.showErrorMessage = true
            }
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
      this.menu = false
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    setInitialData () {
      if (this.initialDate) {
        let dateParts = this.initialDate.split('/')
        let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
        this.date = dateObject.toISOString().substr(0, 10)
        this.lastValidDate = this.date
      } else {
        this.lastValidDate = ''
        this.currentWithoutTerm = this.withoutTerm
      }
    }
  },

  created () {
    this.setInitialData()
  },

  watch: {
    'lastValidDate' () {
      this.dateFormatted = this.formatDate(this.lastValidDate)
    },
    'initialDate' () {
      this.setInitialData()
    }
  }
}
</script>
